import LegalLayout, { Section } from './LegalLayout';

const SOURCES = [
  { label: 'Cryptocurrencies', source: 'CoinGecko public API', freshness: 'Near real-time (≈90s cache)', markets: 'BTC, ETH, and major coins' },
  { label: 'Metals & Oil', source: 'Yahoo Finance', freshness: 'Delayed (≈1 min cache)', markets: 'Gold, Silver, Platinum, Palladium, WTI, Brent' },
  { label: 'Indices: TASI, DFM, Boursa Kuwait', source: 'Yahoo Finance', freshness: 'Delayed (≈90s)', markets: 'Saudi, Dubai, Kuwait' },
  { label: 'Indices: ADX, Qatar (QSI), Bahrain (BAX), Oman (MSM30)', source: 'Public exchange websites (scraped)', freshness: 'Delayed, refreshed periodically', markets: 'Abu Dhabi, Qatar, Bahrain, Oman' },
  { label: 'Stock prices: Saudi, Dubai, Qatar, Kuwait', source: 'Yahoo Finance', freshness: 'Delayed (≈30s)', markets: '.SR / .AE / .QA / .KW listings' },
  { label: 'Top movers: Dubai, Abu Dhabi, Oman', source: 'Public exchange websites (scraped)', freshness: 'Delayed, refreshed periodically', markets: 'DFM, ADX, MSX' },
];

export default function DataSourcesPage() {
  return (
    <LegalLayout title="Data Sources" subtitle="Where our market data comes from" updated="May 2026">
      <Section heading="Important">
        All market data in Ashom is <strong>indicative and may be delayed</strong>. It is obtained from
        the third-party sources below and is <strong>not official, real-time, or guaranteed</strong>.
        Some figures are sample/illustrative where no free source is available (these are clearly
        labelled "Demo data" in the App). Verify any price with the official exchange before relying on
        it.
      </Section>

      <Section heading="Sources by data type">
        <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
          {SOURCES.map((s) => (
            <div key={s.label} style={{ border: '1px solid var(--border)', borderRadius: 10, padding: 12, background: 'var(--card)' }}>
              <p className="font-head" style={{ fontSize: 12.5, fontWeight: 700, color: 'var(--navy)', margin: '0 0 4px' }}>{s.label}</p>
              <p style={{ fontSize: 11.5, margin: '0 0 2px' }}><span style={{ color: 'var(--text-3)' }}>Source: </span>{s.source}</p>
              <p style={{ fontSize: 11.5, margin: '0 0 2px' }}><span style={{ color: 'var(--text-3)' }}>Freshness: </span>{s.freshness}</p>
              <p style={{ fontSize: 11.5, margin: 0 }}><span style={{ color: 'var(--text-3)' }}>Coverage: </span>{s.markets}</p>
            </div>
          ))}
        </div>
      </Section>

      <Section heading="Markets without a free live feed">
        Individual stock prices for <strong>Abu Dhabi (ADX), Bahrain, and Oman</strong> are not
        available from a free source and are shown as clearly-labelled demo values on the relevant
        pages.
      </Section>

      <Section heading="Attribution">
        "Yahoo" and "Yahoo Finance" are trademarks of their respective owner. CoinGecko data is used
        under its public API terms. Exchange data belongs to the respective exchanges (Saudi Exchange,
        DFM, ADX, Qatar Stock Exchange, Boursa Kuwait, Bahrain Bourse, Muscat Stock Exchange).
      </Section>
    </LegalLayout>
  );
}
